import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SchoolProgram = {
  id: string;
  name: string;
};

export type School = {
  id: number;
  connect_user_id: number;

  name: string;
  city: string;
  country: string;

  logo: string;
  profile_link: string;

  programs: SchoolProgram[];
  programsCount: number;
};

type EventDateTime = {
  date: string;
  time: string;
};

type EventDates = {
  start: EventDateTime;
  end: EventDateTime;
  timezone: string;
};

export type Event = {
  title: string;
  id: number | null;
  name: string;
  slug: string;
  dates: EventDates;
  brand: {
    id: number | null;
    name: string;
    slug: string;
  };
  schools: School[];
  isPast: boolean;
}

const initialState: Event = {
  id: null,
  title: "",
  name: "",
  slug: "",
  dates: {
    start: { date: "", time: "" },
    end: { date: "", time: "" },
    timezone: "",
  },
  brand: {
    id: null,
    name: "",
    slug: "",
  },
  schools: [],
  isPast: false,
};

export const eventSlice = createSlice({
  name: 'event',
  initialState: initialState,
  reducers: {
    setEvent: (state, action: PayloadAction<Partial<Event>>) => {
      return { ...state, ...action.payload };
    },
    setEventSchools: (state, action: PayloadAction<School[]>) => {
      state.schools = action.payload;
    },
    setIsPast: (state, action: PayloadAction<boolean>) => {
      state.isPast = action.payload;
    }
  },
});

export const { setEvent, setEventSchools, setIsPast } = eventSlice.actions;

export default eventSlice.reducer;